import { render, staticRenderFns } from "./PurchaseOrderPending.vue?vue&type=template&id=23d8afa0&lang=pug&"
import script from "./PurchaseOrderPending.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderPending.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderPending.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PurchaseOrderPending.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
